import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialogActions,
  MatDialogContent,
  MatDialogTitle,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'ed-privacy-consent-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatDialogActions,
    MatDialogContent,
    MatDialogTitle,
    MatCheckboxModule,
    RouterLink,
  ],
  templateUrl: './privacy-consent-dialog.component.html',
  styleUrl: './privacy-consent-dialog.component.scss',
})
export class PrivacyConsentDialogComponent {
  private dialogRef = inject(MatDialogRef<PrivacyConsentDialogComponent>);

  consent = {
    sentry: true,
    posthog: true,
  };

  showDetails = signal(false);

  acceptAll() {
    this.dialogRef.close({ sentry: true, posthog: true });
  }

  rejectAll() {
    this.dialogRef.close({ sentry: false, posthog: false });
  }

  save() {
    this.dialogRef.close(this.consent);
  }

  toggleDetails() {
    this.showDetails.update((v) => !v);
  }
}
